import React from "react";

import pkg from "../package.json";

import logo from "./assets/logo/logo.svg";
import logoSmall from "./assets/logo/logo-small.svg";

const config = {
  /**
   * Default project rendering scope
   * `oneOf(['react', 'static'])`.
   * If `react` is selected, pages and components will use `React.js` in browser
   * runtime.
   * If `static` is selected, `React.js` will be used as "templating" language
   * and React won't present in browser runtime.
   * This can be overridden per layout in `<Base />`.
   */
  scope: "react",
  /**
   * Project version
   * `string`
   */
  version: pkg.version,
  /** Html lang attribute */
  lang: "en",
  /**
   * Project name.
   * `string`
   */
  name: "Lighter",
  /** Color used as <meta name="theme-color" /> */
  metaTheme: "#ff5722",
  /** Path to styleguide SPA */
  styleguidePath: "styleguide/",
  /**
   * Project logo. Should be text or image.
   * `node`
   */
  logo: <img src={logo} alt="Lighter" />,
  logoSmall: <img src={logoSmall} alt="Lighter" />,
  /**
   * Styleguide theme overrides. Default theme is available (here)[https://github.com/lightingbeetle/lighter/blob/master/packages/styleguide/src/style/theme.js]
   * `object`
   */
  // theme: {
  //   colors: { theme: '#ff7900' },
  // },
};

export default config;
